// PrintContext — a boolean that flips true only while the Report is being exported
// to PDF (window.print). Charts read it via usePrinting() to render at their FINAL,
// static state (skip the scroll-in gate + entrance animations) so the whole report
// is complete in the printed document. Defaults to false everywhere else, so screens
// (e.g. Explore) are unaffected.

import { createContext, useContext } from "react";

export const PrintContext = createContext(false);
export const usePrinting = () => useContext(PrintContext);
